module.exports = __webpack_public_path__ + "img/tecovas.c9dc1e3.svg";